import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import OneColumnLayout from '../../containers/one-column-layout';
//import TwoColumnLayout from '../../blocks/two-column-layout';
//import ThreeColumnLayout from '../../blocks/three-column-layout';
//import FourColumnLayout from '../../blocks/four-column-layout';
import Photogallery from '../../blocks/photogallery';
import Presentation from '../../blocks/presentation';
import Slideshow from '../../blocks/slideshow';
import Slidegallery from '../../blocks/slidegallery';
import Promo from '../../containers/promo';
import Video from '../../blocks/video';
import Html from '../../containers/html';
import Wysiwyg from '../../containers/wysiwyg';

const OneColumnLayoutBlock = props => <OneColumnLayout {...props} />;
OneColumnLayoutBlock.displayName = 'OneColumnLayout';

export default withDynamicComponents({
  componentWhitelist: [
    //OneColumnLayout,
    //ThreeColumnLayout,
    //FourColumnLayout,
    Photogallery,
    Presentation,
    Slideshow,
    Slidegallery,
    Promo,
    Wysiwyg,
    Video,
    Html,
  ],
  mapInputToOutput: [
    ['components', 'components'],
  ],
})(OneColumnLayoutBlock);



// WEBPACK FOOTER //
// ./src/blocks/one-column-layout/index.jsx